/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useEffect, useState, useMemo } from 'react'
import { useHistory } from 'react-router-dom'
import styled from 'styled-components'
import BackgroundImage from '../assets/images/background.jpg'
import {Typography, Card, CardContent, CardHeader} from '@mui/material'

import { LoadingOverlay } from '../components/common'

import { AppContext } from '../stores/AppStore'
import { UserContext } from '../stores/UserStore'

const Background = styled.div`
  background: url(${BackgroundImage}) no-repeat center center fixed;
  background-size: cover;
  background-color: ${({ theme }) => theme.colors.background };
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  font-size: ${({ theme }) => theme.fontSizes.medium};
  color: ${({ theme }) => theme.colors.gray};
  font-weight: bold;
`

const CardBox = styled.div`
  display: flex;
  flex-direction: row;
  font-size: ${({ theme }) => theme.fontSizes.small};
  color: ${({ theme }) => theme.colors.gray};
  text-align: justify;
  width: 100%;
  max-height: 35vh;
  flex-wrap: wrap;
  overflow-y: scroll;
  justify-content: center;

  ::-webkit-scrollbar {
    background-color:#fff;
    width:12px
  }
  
  ::-webkit-scrollbar-track {
    background-color:#fff
  }
  
  ::-webkit-scrollbar-thumb {
    background-color:${({ theme }) => theme.colors.lightGray};
    border-radius:16px;
    border:2px solid #fff
  
  ::-webkit-scrollbar-button {display:none}
`

const CardApp = styled.div`
  font-size: 12px;
  color: ${({ theme }) => theme.colors.metalic};
  border: 1px solid ${({ theme }) => theme.colors.lightGray};
  text-align: center;
  max-width: 100px;
  min-width: 100px;
  max-height: 100px;
  min-height: 100px;
  margin: 4px;
  border-radius: 6px;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  
  img {
    margin-top: 5px;
    max-width: 60px;
    min-width: 60px;
    max-height: 60px;
    min-height: 60px; 
    object-fit: contain; 
  }
  
  span {
    margin: 2px;
  }   
`

const SelectApp = (props) => {
  const history = useHistory()

  const { logo } = useContext(AppContext)
  const { applications, app, loadApp, authState } = useContext(UserContext)
  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    if (applications) {
      loadApp().then().catch(error => {
        history.replace('/select-app')
      })
    } 
  }, [applications])     

  useEffect(() => {
    // if (app) {
    //   if (authState === 'SIGNED_IN') {
    //   }
    // } 
  }, [app, authState])


  const onGoToLogin = (app) => (event) => {
    setIsLoading(true)    
    history.replace('/login?app='+app.id)
  }

  const renderBackground = useMemo(() => <Background>
    <Card sx={{ width:'40vw', height:'50vh', padding:'10px', display: 'flex', flexDirection: 'column', justifyContent:'stretch', alignItems:'stretch' }}>
        <CardHeader sx={{flex: '6vh 0'}} avatar={ <img src={logo} style={{height: '5vh'}} alt="logo" /> } title={<Typography variant="h5" color="textSecondary" component="h2">Select an Application</Typography>} />               
        <CardContent sx={{ flex: '1 0', display: 'flex', flexDirection: 'column', justifyContent:'center', alignItems:'center' }}>
          <CardBox>
            { applications.filter(app => app.isActive ).map(app => (
              <CardApp key={app.id} onClick={onGoToLogin(app)}>
                <img src={app.icon} alt={app.label}></img>
                <span>{app.label}</span>
              </CardApp>
            )) }
          </CardBox>
        </CardContent>
    </Card>
    <LoadingOverlay visible={isLoading}/>  
  </Background>, [applications, app, logo, isLoading])     

  return ( renderBackground )
}

export default SelectApp